module.exports = __webpack_public_path__ + "img/FIA.370b47d8.png";